import React, {type ReactNode} from 'react'
import css from './Button.module.css'
import TextMiddBold from "@/components/ui/Text/TextMiddBold.tsx"
import Loader from "@/components/ui/Loader/Loader"

interface ButtonProps {
    icon?: ReactNode
    title?: ReactNode
    disabled?: boolean
    loading?: boolean
    round?: boolean
    onClick?: () => void
    type?: 'black'
        | 'white'
        | 'light'
        | 'light_on_dark'
        | 'black_on_dark'
        | 'danger'
        | 'danger_transparent'
        | 'transparent'
    size?: 'medium'
    testId?: string
}

const Button = ({icon, title, disabled = false, loading = false, round = false, onClick, type, size, testId}: ButtonProps) => {
    const className = [
        css.button,
        disabled && css.disabled,
        loading && css.loading,
        round && css.round,
        type === 'black' && css.black,
        type === 'white' && css.white,
        type === 'danger' && css.danger,
        type === 'danger_transparent' && css.danger_transparent,
        type === 'light' && css.light,
        type === 'light_on_dark' && css.light_on_dark,
        type === 'black_on_dark' && css.black_on_dark,
        size === 'medium' && css.medium
    ].filter(Boolean).join(' ')

    const handleMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        if (onClick && !disabled && !loading) {
            onClick()
        }
    }

    return (
        <button
            className={className}
            disabled={disabled || loading}
            onClick={handleMouseDown}
            data-testid={testId}
        >
            {loading && <div className={css.loader_container}><Loader /></div>}
            {icon && <span className={css.icon}>{icon}</span>}
            {title && <span className={css.title}><TextMiddBold>{title}</TextMiddBold></span>}
        </button>
    )
}

export default Button
